const { DANGER_SIGNS } = require('../all/conditions/categories');

const CONDITIONS_BY_PATIENT = {
  child: [
    'ds_convulsions',
    'ds_vomits_everything',
    'ds_lethargic_or_unconscious',
    'ds_much_less_drinking',
    'ds_much_less_latching',
  ],
  newborn: [
    'ds_convulsions',
    'ds_lethargic_or_unconscious',
    'ds_much_less_latching',
    'ds_chest_indrawing',
    'ds_respiratory_rate_high',
    'ds_temperature_high',
    'ds_temperature_low',
  ],
};

const CONDITION_NAMES = new Set(Object.values(CONDITIONS_BY_PATIENT).flat());

function getDangerSignNames(patient) {
  const names = CONDITIONS_BY_PATIENT[patient];
  return Array.isArray(names) ? [...names] : [];
}

function isDangerSign(name) {
  return CONDITION_NAMES.has(name);
}

function getDangerSignMetadata(patient) {
  return getDangerSignNames(patient).map(name => ({ name, categories: [DANGER_SIGNS] }));
}

// Callers own the engagement setting; this helper only applies the patient mapping.
function configureDangerSignConditions(conditions, patient) {
  const names = getDangerSignNames(patient);
  if (!names.length) return conditions;

  const configuredNames = new Set(conditions.map(condition => condition.name));
  const additionalConditions = names
    .filter(name => !configuredNames.has(name))
    .map(name => ({ name, plans: [] }));

  return [...conditions.filter(condition => condition.name !== 'seizure'), ...additionalConditions];
}

function getDangerSignSbiQuestions(condition, classifications, conditionNames) {
  if (condition.name !== 'serious_bacterial_infection'
    || classifications.patient !== 'newborn'
    || classifications.audience !== 'chw'
    || classifications.experience !== 'pwa'
    || !CONDITIONS_BY_PATIENT.newborn.some(name => conditionNames.includes(name))) {
    return condition.questions;
  }

  // CSV rows are shared across assessments. Copy the scoped changes on each call.
  const questions = condition.questions.map(question => {
    if (question.name === 'respiratory_rate'
      && question.operator === 'gt' && question.response === '60') {
      return { ...question, operator: 'gte' };
    }
    return question;
  });
  questions.push({
    audience: 'chw',
    patient: 'newborn',
    experience: 'pwa',
    condition: 'serious_bacterial_infection',
    name: 'temperature',
    operator: 'gte',
    response: '37.5',
    score: '17',
  });
  return questions;
}

module.exports = {
  getDangerSignNames,
  isDangerSign,
  getDangerSignMetadata,
  configureDangerSignConditions,
  getDangerSignSbiQuestions,
};
